export * from './csv';
export * from './day';
export * from './school';
export * from './string';
export * from './timeout';
export * from './validators';

/**
 * It will remove empty Objects, empty array, null, undefined, empty strings with any level
 * including from array of objects.
 * Also handles array of strings. Does not need to be array of objects anymore
 * @param obj
 * @returns {{}}
 */
export const cleanObject = function (obj: any) {
  const finalObj: any = {};
  Object.keys(obj).forEach(key => {
    if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      const nestedObj = cleanObject(obj[key]);
      if (Object.keys(nestedObj).length) {
        finalObj[key] = nestedObj;
      }
    } else if (Array.isArray(obj[key])) {
      if (obj[key].length) {
        obj[key].forEach((x: any) => {
          if (typeof x === 'string') {
            //handle array of strings here
            finalObj[key] = obj[key];
          } else {
            const nestedObj = cleanObject(x);
            if (Object.keys(nestedObj).length) {
              finalObj[key] = finalObj[key] ? [...finalObj[key], nestedObj] : [nestedObj];
            }
          }
        });
      }
    } else if (obj[key] !== '' && obj[key] !== undefined && obj[key] !== null) {
      finalObj[key] = obj[key];
    }
  });
  return finalObj;
};

/**
 * Removes fields that are null and emty from object. 
 * Returns undefined in all items in object get removed
 * @param obj {}
 * @returns obj | undefined
 */
export const nullAndEmptyStringToundefined = (obj: any) => {
  let finalObj: any | undefined = {};
  if (obj && Object.keys(obj).length > 0) {
    Object.keys(obj).forEach(key => {
      if (obj[key] && obj[key] !== '') finalObj[key] = obj[key];
    });
  } else {
    finalObj = undefined
  }
  return  finalObj;
};

/**
 * Removes fields that are null and emty from object. 
 * Returns undefined in all items in object get removed
 * @param obj {}
 * @returns obj | {}
 */
export const nullAndEmptyStringToEmptyObj = (obj: any) => {
  let finalObj: any | undefined = {};
  if (obj && Object.keys(obj).length > 0) {
    Object.keys(obj).forEach(key => {
      if (obj[key] && obj[key] !== '') finalObj[key] = obj[key];
    });
  }
  return  finalObj;
};


export const convertToNumber = (value: any): number | undefined => {
  if (typeof value === 'string') {
    const parsed = parseInt(value);
    return isNaN(parsed) ? undefined : parsed;
  } else if (typeof value === 'number') {
    return value;
  }
  return undefined;
};